import { render, staticRenderFns } from "./wechatlist.vue?vue&type=template&id=e80951f8&scoped=true"
import script from "./wechatlist.vue?vue&type=script&lang=js"
export * from "./wechatlist.vue?vue&type=script&lang=js"
import style0 from "@/styles/public1.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./wechatlist.vue?vue&type=style&index=1&id=e80951f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80951f8",
  null
  
)

export default component.exports